
/**
 * [ File :: G_Wrapper.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/frame/G_Wrapper.js
 * @목적 : 해당 클래스는 G_Canvas를 감싸고 숨기는 캔버스 입니다.
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

import G_Canvas  from 'canvas/grid/dev/frame/G_Canvas'
import B_Wrapper from 'canvas/base/dev/frame/B_Wrapper'
import G_Define  from 'canvas/grid/dev/util/G_Define'
import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';

const G_Wrapper = (function(){
	return class extends B_Wrapper {
		constructor(id, queue, cb) { super(id, queue, cb, G_Canvas); }

		/**
       * [ Function :: setVariable ]
       *
       * @DES :: 변수를 설정하기 위한 함수
       * @IP1 :: inputJson {id: str, value: any}
       * @O.P :: null
       */
		setVariable (inputJson) {
			const cloneJson = B_Util.clone(inputJson)

			cloneJson.type = G_Define.VARIABLE_REAL_TYPE

			if (
				this._objCanvas.WORLD[cloneJson.id] &&
				typeof this._objCanvas.WORLD[cloneJson.id].remove === 'function'
			) this._objCanvas.WORLD[cloneJson.id].remove()

			this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson)
		}

		getAllVariable () {
			const res = {}
			Object.keys(this._objCanvas.WORLD.LIST[G_Define.VARIABLE_REAL_TYPE]).forEach(e => {
				const variable = this._protectedCanvas.world[e]
				res[e] = B_Util.getProtected(variable)
			})
			return res
		}

		addSolution (inputJson) {
			// /*[T]*/console.log('addSolution in B_Wrapper');

			// [#] 외부노출제거
			const cloneJson = B_Util.clone(inputJson)

			if (typeof cloneJson.answerSheet.res === 'object') { // 오브젝트의 좌표가 변할 때마다 처리 되는 솔루션
				cloneJson.type = G_Define.RESOURCE_SOLUTION_TYPE
			} else if (typeof cloneJson.answerSheet.position === 'object') { // RESOURCE_SOLUTION_TYPE 동일하나 좌표 기준으로 등록 되는 솔루션
				cloneJson.type = G_Define.POSITION_SOLUTION_TYPE
			} else if (typeof cloneJson.answerSheet.action === 'object') { // action이 끝난 후에 처리 되는 솔루션
				cloneJson.type = G_Define.ACTION_SOLUTION_TYPE
			} else if (typeof cloneJson.answerSheet.variable === 'object' && cloneJson.live === true) { // 변수의 값이 변화될 때마다 처리 되는 솔루션
				cloneJson.type = G_Define.VARIABLE_SOLUTION_TYPE
			} else if (cloneJson.live === true) { // 아이템을 획득할 때마다 처리 되는 솔루션
				cloneJson.type = G_Define.ITEM_SOLUTION_TYPE
			} else { // goal에서 처리하는 솔루션
				cloneJson.type = B_Define.SOLUTION_TYPE
			}

			this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
		}
	}
}());
export default G_Wrapper;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/frame/G_Wrapper.js